import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { VisualizacaoStorageService } from '../../services/visualizacao-storage';
import { Filter } from '../../../models';
import { BaseFilterCollapse } from '../../services/filter';

/**
 * Service com métodos para os components de visualização da aplicação
 */
@Injectable({
    providedIn: 'root'
})
export class BaseVisualizacaoService {

    constructor(private router: Router,
                private visualizacaoStorageService: VisualizacaoStorageService) { }

    /**
     * Realiza o insert e redereciona para o component de cadastro
     */
    insert(activatedRoute: ActivatedRoute) {
        this.router.navigate(['./novo'], {relativeTo:  activatedRoute});
    }

    /**
     * Realiza o edit e redereciona para o component de cadastro
     */
    edit(id: number, activatedRoute: ActivatedRoute) {
        this.router.navigate(['./', id], {relativeTo:  activatedRoute});
    }

    /**
     * Realiza redereciona para o component de cadastro quando for para somente ler/consultar o registro
     */
    read(id: number, activatedRoute: ActivatedRoute) {
        this.router.navigate(['./', id], {relativeTo:  activatedRoute});
    }


    /**
     * Redereciona para o component de cadastro para realizar a duplicação da entidade
     */
    duplicate(id: number, activatedRoute: ActivatedRoute) {
        this.router.navigate(['./', id, 'duplicar'], {relativeTo:  activatedRoute});
    }

    /**
     * Ativa o armazenamento dos dados da visualização, tais como, a páginação, ordenação e filtro atual da tabela e o filtro avançado
     */
    ativarArmazenamento(dataTable: any, filter: Filter) {
        setTimeout(() => {
            // Aplicando o filtro e a página atual da tabela armazenados nos dados da visualização
            dataTable.search(this.visualizacaoStorageService.getFilterSearch())
                    .page(this.visualizacaoStorageService.getCurrentPage());

            // Aplicando a ordenação da tabela quando a mesma estiver armazenada
            const order = this.visualizacaoStorageService.getOrder();
            if (order && order.length > 0) {
                dataTable.order(order);
            }
            // Redezenhado a tabela para aplicar as alterações dos dados armazenados
            dataTable.draw(false);


            // Registrando os eventos da tabela
            dataTable.on('page.dt', () => { // Evento de troca das páginas da tabela
                this.visualizacaoStorageService.set(filter, this.visualizacaoStorageService.getFilterSearch(), dataTable.page.info().page, this.visualizacaoStorageService.getOrder());
            }).on('search.dt', (e) => { // Evento da pesquisa da tabela
                this.visualizacaoStorageService.set(filter, dataTable.search(), this.visualizacaoStorageService.getCurrentPage(), this.visualizacaoStorageService.getOrder());
            }).on('order.dt', (e) => { // Evento da ordenação da tabela
                this.visualizacaoStorageService.set(filter, this.visualizacaoStorageService.getFilterSearch(), dataTable.page.info().page, dataTable.order());
            });

            // Armazenando os dados atuais da visualização
            this.visualizacaoStorageService.set(filter, dataTable.search(), dataTable.page.info().page, dataTable.order());
        }, 500);
    }

    /** Aplica o filtro avançado armazenado no objeto do filtro informado */
    aplicarFiltroArmazenado(filter: Filter, filterCollapse: BaseFilterCollapse = null) {
        this.visualizacaoStorageService.applyFilter(filter, filterCollapse);
    }
}
